module.exports = __webpack_public_path__ + "static/media/pork.2ba34af6.jpg";